import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate } from "react-router-dom";
import categoriasServices from '../../services/categoriasServices';
import { InputContext } from '../../contexts/InputContext';
import MessageModal from '../../container/MessageModal';
import { errorClassification } from '../../errorHandler';

const ListaCategorias = () => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)

  const [categorias, setCategorias] = useState([]);
  const [renderHTML, setRenderHTML] = useState(false);

  // modal messages
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');
  const handleShowModal = (message) => {setModalBody(message); setShowModal(true)};
  const handleCloseModal = () => { setShowModal(false); setModalBody('') };

  useEffect(() => {
    obtenerCategorias();
  }, []);

  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( (authInformation.autenticado === true) && (authInformation.rol === 'Admin' || authInformation.rol === 'Veedor')){
      setRenderHTML(true)
    } else {
      setRenderHTML(false)
    }
  }, [authInformation]);

  const obtenerCategorias = async () => {
    try {
      const data = await categoriasServices.obtenerCategorias();

      setCategorias(data);
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const eliminarCategoria = async (categoria) => {
    try {
      if(window.confirm(`Está seguro que quiere eliminar a ${categoria.titulo_completo}?`)){
        await categoriasServices.eliminarCategoria(categoria.id);

        const copiaCategorias = [...categorias];
        setCategorias(copiaCategorias.filter((categorias) => categorias.id !== categoria.id))
      }

    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const listarCategorias = categorias && categorias.map((categoria, index) => {
    return (
      <tr key={index}>
        <td>{categoria.codigo}</td>
        <td>{categoria.titulo}</td>
        <td>{categoria.abreviacion}</td>
        <td>
        {authInformation.rol === 'Admin' ? (
          <div className="btn-group" role="group">
            <Link className="btn btn-primary" to={`/categoria/${categoria.id}/edit`}>Editar</Link>{' '}
            <button className="btn btn-danger" onClick={()=>eliminarCategoria(categoria)} >Eliminar</button>
          </div>
        ) : ('')
        }
        </td>
    </tr>
    )
  })

  return (
    <>
      <h1>Lista de categorías</h1>
      {
        (renderHTML) && (
          <>
          <div className="table-responsive small">
            <table className="table table-striped table-sm">
              <thead>
                <tr>
                  <th scope="col">Código</th>
                  <th scope="col">Título</th>
                  <th scope="col">Abreviación</th>
                  <th scope="col">Acción</th>
                </tr>
              </thead>
              <tbody>
                {listarCategorias}
              </tbody>
            </table>
          </div>
          </>
        )
      }
      <MessageModal
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        modalBody={modalBody}
     />
      </>

  );
};

export default ListaCategorias;